// Footer collapsible menus
function initFooterMenus() {
  document.querySelectorAll('.footer-menu__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      var list = document.getElementById(this.getAttribute('aria-controls'));
      if (expanded) {
        list.setAttribute('hidden', '');
        this.querySelector('.footer-menu__icon').textContent = '+';
      } else {
        list.removeAttribute('hidden');
        this.querySelector('.footer-menu__icon').textContent = '−';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initFooterMenus);
setTimeout(initFooterMenus, 2000);
